export function dateSort(array) {
	return array.sort((a, b) => {
		const [Aday, Amonth, Ayear] = a.requestsAdjustmentDate.split('.')
		const [Bday, Bmonth, Byear] = b.requestsAdjustmentDate.split('.')
		return new Date(Byear, Bmonth - 1, Bday) - new Date(Ayear, Amonth - 1, Aday)
	})
}
